import _ from 'lodash'

import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { getCordovaReadyPromise } from '@utils/cordovaChecker'
import {
    startBarcodeScannerHexProfile,
    resetBarcodeScannerProfile,
    captureBarcodeScan,
} from '@utils/Barcode/barcodeScanner'

/**
 * Cross frame listener for barcode scanner.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'startHexProfile', etc...
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function captureBarcodeScanner (message: any) {

    return getCordovaReadyPromise().then(() => {
        if (_.isObject(message.data) && _.isString(message.data.action)) {
            if (message.data.action === 'startHexProfile') {
                return startBarcodeScannerHexProfile()
            } else if (message.data.action === 'resetScannerProfile') {
                return resetBarcodeScannerProfile()
            } else {
                return captureBarcodeScan()
            }
        }
        return PromiseUtils.newRejectedPromiseWithErrorMessage('No action specified.')
    }, () => {
        console.debug('Cordova not available, will capture from barcode scanner.')
        return PromiseUtils.newRejectedPromiseWithErrorMessage('Cordova is not available in this window.')
    })
}
